import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=3a8bfd4e&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"
import style0 from "./Login.vue?vue&type=style&index=0&id=3a8bfd4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8bfd4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a8bfd4e')) {
      api.createRecord('3a8bfd4e', component.options)
    } else {
      api.reload('3a8bfd4e', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=3a8bfd4e&scoped=true&", function () {
      api.rerender('3a8bfd4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Login.vue"
export default component.exports